<script lang="ts">
    import type { MapLayerOneType } from '../../utilities/MapLayer/MapLayerApi';
    import Switch from '../../shared/Switch.svelte';
    import { AdminApi } from './AdminApi';
    import type { Account } from './Account';
    import { api } from '../../../stores/api';
    import WarningColor from '../../shared/WarningColor.svelte';

    export let allMapLayers: MapLayerOneType[] = [];
    export let account: Account;

    let somethingWasChanged = false;
</script>

<div style="display: flex;  row-gap: 3px; flex-direction: column;">
    {#if somethingWasChanged}
        <WarningColor>Changes will be visible on map after reloading page (F5)</WarningColor>
    {/if}
    {#each allMapLayers as layer (layer.id)}
        <div style="display: flex; flex-direction: row; align-items: center;">
            <Switch
                checked={account.getEnabledMapLayers().includes(layer.id)}
                label={layer.label}
                on:change={e => {
                    let checked = e.detail.checked;
                    somethingWasChanged = true;
                    account.setEnabledMapLayer(layer.id, checked);
                    account = account;
                    AdminApi.updateSettingsReadonly(
                        $api,
                        account.getCustomerId(),
                        account.getSettingsReadonly()
                    );
                }}
            />
        </div>
    {/each}
</div>
